// Bounded map API client for the Zillow-style Opportunities map.
// Calls ONLY the existing GET /api/map/opportunities (read-only; never triggers Match scoring).
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// OpenFreeMap Liberty vector style — no API key, no account. MapLibre-native. Liberty shows
// materially more highway/major-road context and road shields than Positron for orientation.
export const OPENFREEMAP_STYLE = 'https://tiles.openfreemap.org/styles/liberty';

// Sensible national default viewport when no trusted user coordinate exists.
export const US_DEFAULT = { center: [-98.5, 39.5], zoom: 3.6 };

// Translate the authoritative Opportunities source selection into the API's opportunity_type.
export function oppTypeParam({ jobs, skillbridge }) {
  if (jobs && skillbridge) return undefined; // all
  if (jobs) return 'employment';
  if (skillbridge) return 'skillbridge';
  return undefined;
}

// One bounded request for the current viewport. `layers` = subset of ['jobs','continuity'].
export async function fetchMapArea({ bounds, zoom, layers, opportunity_type, remote, job_type,
                                     component, branch, vw, saved_only }) {
  const p = new URLSearchParams();
  p.set('north', bounds.north); p.set('south', bounds.south);
  p.set('east', bounds.east); p.set('west', bounds.west);
  if (zoom != null) p.set('zoom', Math.round(zoom));
  if (vw != null) p.set('vw', Math.round(vw));
  if (layers && layers.length) p.set('layers', layers.join(','));
  if (opportunity_type) p.set('opportunity_type', opportunity_type);
  if (remote === true || remote === 'true') p.set('remote', 'true');
  if (remote === false || remote === 'false') p.set('remote', 'false');
  if (job_type) p.set('job_type', job_type);
  if (saved_only) p.set('saved_only', 'true');
  if (component) p.set('component', component);
  if (branch) p.set('branch', branch);
  const res = await axios.get(`${BACKEND_URL}/api/map/opportunities?${p.toString()}`,
    { withCredentials: true });
  return res.data;
}
